import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  /** Muda quando a área troca → reseta o boundary. */
  resetKey: string;
  children: ReactNode;
}
interface State {
  error: Error | null;
}

/** Captura erros de render de uma área para não derrubar o shell inteiro (F-07). */
export class AreaErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('Erro na área:', error, info.componentStack);
  }

  override componentDidUpdate(prev: Props) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  override render() {
    if (this.state.error) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            gap: 12,
            padding: '64px 24px',
            minHeight: 280,
            border: '1px dashed var(--border)',
            borderRadius: 'var(--r-lg)'
          }}
        >
          <h3 style={{ fontSize: 15.5, color: 'var(--danger)' }}>Algo quebrou nesta área</h3>
          <p style={{ fontSize: 13.5, color: 'var(--text-2)', maxWidth: 420 }}>
            {this.state.error.message}
          </p>
          <button
            className="focusable"
            onClick={() => this.setState({ error: null })}
            style={{
              fontSize: 13,
              fontWeight: 600,
              padding: '7px 14px',
              borderRadius: 'var(--r-sm)',
              border: '1px solid var(--border)',
              background: 'var(--bg-2)',
              color: 'var(--text-0)',
              cursor: 'pointer'
            }}
          >
            Tentar novamente
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
